import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface ImageModalProps {
  children: React.ReactNode;
  html?: string;
}

type ModalEvent =
  | React.MouseEvent<HTMLDivElement>
  | KeyboardEvent;

const ImageModal: React.FC<ImageModalProps> = ({ children, html }) => {
  // The wrapper should expand regardless of the parendNode.
  const [showModal, setShowModal] = useState(false);

  const openModal = () => {
    document.body.classList.add('no-scroll');
    setShowModal(true);
  };

  const closeModal = (event: ModalEvent) => {
    const nodeName = event.target instanceof HTMLElement ? event.target.nodeName : '';

    if (nodeName !== 'IMG') {
      document.body.classList.remove('no-scroll');
    }

    return setShowModal(false);
  };

  return (
    <>
      <div
        className='zoom-content'
        onClick={openModal}
      >
        {children}
      </div>
      {showModal &&
        createPortal(
          <ImageModalComponent
            closeModal={closeModal}
            image={!html ? children : null}
            html={html}
          />,
          document.body
        )}
    </>
  );
};

interface ImageModalComponentProps {
  closeModal: (event: ModalEvent) => void;
  image: React.ReactNode;
  html?: string;
}

const ImageModalComponent: React.FC<ImageModalComponentProps> = ({
  closeModal,
  image,
  html,
}) => {
  const escapeHandler = (event: KeyboardEvent) => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      closeModal(event);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', escapeHandler);

    return () => document.removeEventListener('keydown', escapeHandler);
  }, []);

  return (
    <div
      className='zoom-overlay'
      onClick={closeModal}
    >
      <div className='zoom-overlay__inner'>
        {html && (
          <div
            className='zoom-overlay__iframe'
            dangerouslySetInnerHTML={{ __html: html }}
          />
        )}
        {image ? image : null}
        <div className='zoom-overlay__close'>X</div>
      </div>
    </div>
  );
};

export default ImageModal;
